export default __webpack_public_path__ + "static/media/tatianemodena-3-700x1080Tiny.f1aa1661.png";